import { useContext } from 'react';
import BillingContext from './BillingContext.jsx';

export function useBilling() {
  const ctx = useContext(BillingContext);
  if (!ctx) throw new Error('useBilling must be used within a BillingProvider');
  return ctx;
}

export default useBilling;
